import { render, staticRenderFns } from "./MobileMessage.vue?vue&type=template&id=42a25bbd&"
import script from "./MobileMessage.vue?vue&type=script&lang=js&"
export * from "./MobileMessage.vue?vue&type=script&lang=js&"
import style0 from "./MobileMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports